type CampaignCreateStep = 1 | 2 | 3;

type CampaignCreateCopyInput = {
  currentStep: CampaignCreateStep;
  hasCreators: boolean;
  hasPostUrls: boolean;
};

type CampaignCreatePrimaryActionInput = {
  currentStep: CampaignCreateStep;
  hasCreators: boolean;
  hasCreatorIssues: boolean;
};

type CampaignCreateFooterUsageInput = {
  usedCount: number;
  limit: number;
};

export function getCampaignCreateStepDescription({
  currentStep,
  hasCreators,
  hasPostUrls,
}: CampaignCreateCopyInput) {
  if (currentStep === 2) {
    return 'Track posts automatically from creators you add\nOr skip this step and add post URLs instead';
  }

  if (currentStep !== 3) {
    return undefined;
  }

  if (hasCreators && !hasPostUrls) {
    return "Add post URLs to track specific content\nOptional — we'll already track posts from your creators";
  }

  if (!hasCreators) {
    return 'Add at least one post URL to start tracking';
  }

  return "Add post URLs to track specific content\nOptional — we'll already track posts from your creators";
}

export function getCampaignCreatePrimaryActionLabel({
  currentStep,
  hasCreators,
  hasCreatorIssues,
}: CampaignCreatePrimaryActionInput) {
  if (currentStep === 2 && !hasCreatorIssues && !hasCreators) {
    return 'Skip to post URLs';
  }

  if (currentStep === 3) {
    return 'Create campaign';
  }

  return 'Continue';
}

export function getCreatorCountBadge(creatorCount: number): string {
  return `${creatorCount} creator${creatorCount === 1 ? '' : 's'}`;
}

export function getPostCountBadge(postCount: number): string {
  return `${postCount} post URL${postCount === 1 ? '' : 's'}`;
}

export function getCampaignCreateFooterUsageLabel({
  usedCount,
  limit,
}: CampaignCreateFooterUsageInput) {
  return `${usedCount} / ${limit} creators or post URLs`;
}
